import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ORG } from "../../data/costant";
import FrontendLayout from "../FrontendLayout";

const getStoredReceipt = () => {
  try {
    const storedReceipt = sessionStorage.getItem("lastBookingReceipt");
    return storedReceipt ? JSON.parse(storedReceipt) : null;
  } catch (error) {
    return null;
  }
};

export default function BookingReceipt() {
  const location = useLocation();
  const navigate = useNavigate();
  const receipt = location.state?.receipt || getStoredReceipt();

  if (!receipt) {
    return (
      <FrontendLayout>
        <main className="quote-flow-page booking-receipt-page">
          <div className="container booking-receipt-container">
            <section className="booking-receipt-empty">
              <span className="booking-receipt-success-icon is-muted">
                <i className="fa fa-file-alt"></i>
              </span>
              <h1>Receipt unavailable</h1>
              <p>Your latest booking receipt could not be found.</p>
              <button
                type="button"
                className="quote-primary-action"
                onClick={() => navigate("/bookings")}
              >
                View my bookings <i className="fa fa-arrow-right"></i>
              </button>
            </section>
          </div>
        </main>
      </FrontendLayout>
    );
  }

  const { bookingId, amount, tax, total, distance, formData, createdAt } = receipt;
  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleString("en-IN", {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : "-";

  return (
    <FrontendLayout>
      <main className="quote-flow-page booking-receipt-page">
        <div className="container booking-receipt-container">
          <section className="booking-success-heading">
            <span className="booking-receipt-success-icon">
              <i className="fa fa-check"></i>
            </span>
            <span className="quote-flow-eyebrow">Booking confirmed</span>
            <h1>Your booking is successful</h1>
            <p>Your transport request has been received. Keep this receipt for reference.</p>
          </section>

          <article className="booking-receipt-card" id="bookingReceipt">
            <header className="booking-receipt-header">
              <div>
                <span className="booking-receipt-brand">{ORG.name}</span>
                <p>{ORG.email} · +91 {ORG.mobile}</p>
              </div>
              <div className="booking-receipt-number">
                <span>Booking receipt</span>
                <strong>#{bookingId || "N/A"}</strong>
              </div>
            </header>

            <div className="booking-receipt-body">
              <div className="booking-receipt-meta">
                <div>
                  <span>Customer</span>
                  <strong>{formData?.name || "-"}</strong>
                </div>
                <div>
                  <span>Mobile</span>
                  <strong>{formData?.mobile || "-"}</strong>
                </div>
                <div>
                  <span>Booking date</span>
                  <strong>{formattedDate}</strong>
                </div>
                <div>
                  <span>Payment mode</span>
                  <strong>Cash on Delivery</strong>
                </div>
              </div>

              <section className="booking-receipt-route">
                <div>
                  <span className="booking-route-marker pickup">
                    <i className="fa fa-map-marker-alt"></i>
                  </span>
                  <div>
                    <small>Pickup location</small>
                    <strong>{distance?.pickupLocation || "-"}</strong>
                  </div>
                </div>
                <span className="booking-receipt-route-line"></span>
                <div>
                  <span className="booking-route-marker drop">
                    <i className="fa fa-flag-checkered"></i>
                  </span>
                  <div>
                    <small>Drop location</small>
                    <strong>{distance?.dropLocation || "-"}</strong>
                  </div>
                </div>
              </section>

              <div className="booking-receipt-shipment">
                <div>
                  <span>Truck</span>
                  <strong>{formData?.selectedTruck?.label || "-"}</strong>
                </div>
                <div>
                  <span>Category</span>
                  <strong>{formData?.selectedCategory?.label || "-"}</strong>
                </div>
                <div>
                  <span>Weight</span>
                  <strong>{formData?.weight || "-"} {formData?.weightType || ""}</strong>
                </div>
                <div>
                  <span>Journey</span>
                  <strong>{distance?.distance || "-"} · {distance?.duration || "-"}</strong>
                </div>
              </div>

              <section className="booking-receipt-total">
                <div>
                  <span>Transport amount</span>
                  <strong>₹{amount ?? "-"}</strong>
                </div>
                <div>
                  <span>Applicable tax</span>
                  <strong>₹{tax ?? "-"}</strong>
                </div>
                <div className="booking-receipt-grand-total">
                  <span>Total amount</span>
                  <strong>₹{total ?? "-"}</strong>
                </div>
              </section>
            </div>

            <footer className="booking-receipt-footer">
              <span><i className="fa fa-shield-alt"></i> Booking recorded securely</span>
              <span>Thank you for choosing {ORG.name}</span>
            </footer>
          </article>

          <div className="booking-receipt-actions">
            <button
              type="button"
              className="quote-secondary-action"
              onClick={() => navigate("/bookings")}
            >
              <i className="fa fa-list-alt"></i> My bookings
            </button>
            <button
              type="button"
              className="quote-primary-action"
              onClick={() => window.print()}
            >
              Print receipt <i className="fa fa-print"></i>
            </button>
          </div>
        </div>
      </main>
    </FrontendLayout>
  );
}
